import { memo, useId } from 'react';
import ContTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ContTitle';
import SwiperNavigation from '@wconcept/wconcept-ui-renewal/components/molecules/SwiperNavigation';
import ItemsSwiper from '@wconcept/wconcept-ui-renewal/src/components/atoms/ItemsSwiper';
import ItemsScrollBar from '@wconcept/wconcept-ui-renewal/components/atoms/ItemsScrollBar';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface CustomColorType {
  bgColor?: string;
  textColor?: string;
}

type ColorType = 'white' | 'black' | CustomColorType | string;

interface IProps {
  title?: string;
  subTitle?: string;
  colorType?: ColorType;
  children?: React.ReactNode;
  isDesktop?: boolean;
}

const RltdContentsSection = ({
  title = '함께 보면 좋을 콘텐츠',
  subTitle,
  colorType = 'white',
  children,
  isDesktop,
}: IProps) => {
  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;

  const cName = classNameBind([
    'related-content',
    !isCustomColor ? `bg-type-${colorType}` : '',
  ]);
  const childCnt = children instanceof Array ? children?.length : 0;

  const id = useId();
  const safeId = id.replace(/:/g, '');
  const uniqueKeyNavi = `swiper-navi-${safeId}`;

  const paramPc: any = {
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: 18,
    autoplay: false,
    loop: false,
    navigation: {
      prevEl: `.${uniqueKeyNavi} .swiper-button-prev`,
      nextEl: `.${uniqueKeyNavi} .swiper-button-next`,
    },
    navigationEl: childCnt > 4 && (
      <SwiperNavigation className={uniqueKeyNavi} offsetTop={132.5} />
    ),
  };

  return (
    <S.RltdContentsSection
      className={cName}
      $bgColor={customColors?.bgColor}
      $textColor={customColors?.textColor}
    >
      <ContTitle
        title={title}
        subTitle={subTitle}
        titleColor={customColors?.textColor}
        subTitleColor={customColors?.textColor}
      />

      <div className={`content-list ${childCnt < 6 ? 'flex' : ''}`}>
        {isDesktop ? (
          <>
            {childCnt < 6 ? (
              children
            ) : (
              <ItemsSwiper {...paramPc}>{children}</ItemsSwiper>
            )}
          </>
        ) : (
          <ItemsScrollBar perView={1.277} colGap={10} snap>
            {children}
          </ItemsScrollBar>
        )}
      </div>
    </S.RltdContentsSection>
  );
};

export default memo(RltdContentsSection);
